
import { PersonalInfoStep } from "./formSteps/PersonalInfoStep";
import { NutritionStep } from "./formSteps/NutritionStep";
import { FitnessStep } from "./formSteps/FitnessStep";
import { SleepStep } from "./formSteps/SleepStep";
import { SupplementStep } from "./formSteps/SupplementStep";
import { MindfulnessStep } from "./formSteps/MindfulnessStep";
import { GoalsStep } from "./formSteps/GoalsStep";
import { OnboardingFormData } from "@/hooks/useOnboardingForm";

interface OnboardingStepRendererProps {
  currentStep: number;
  formData: OnboardingFormData;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleCheckboxChange: (list: string, value: string) => void;
  handleSelectChange: (name: string, value: string) => void;
  handleRadioChange: (name: string, value: string) => void;
}

export function OnboardingStepRenderer({
  currentStep,
  formData,
  handleInputChange,
  handleCheckboxChange,
  handleSelectChange,
  handleRadioChange
}: OnboardingStepRendererProps) {
  switch (currentStep) {
    case 0:
      return (
        <PersonalInfoStep
          formData={formData}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          handleRadioChange={handleRadioChange}
        />
      );
    
    case 1:
      return (
        <NutritionStep
          formData={formData}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          handleCheckboxChange={handleCheckboxChange}
        />
      );
    
    case 2:
      return (
        <FitnessStep
          formData={formData}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          handleCheckboxChange={handleCheckboxChange}
        />
      );
    
    case 3:
      return (
        <SleepStep
          formData={formData}
          handleSelectChange={handleSelectChange}
          handleCheckboxChange={handleCheckboxChange}
        />
      );
    
    case 4:
      return (
        <SupplementStep
          formData={formData}
          handleInputChange={handleInputChange}
        />
      );
    
    case 5:
      return (
        <MindfulnessStep
          formData={formData}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          handleCheckboxChange={handleCheckboxChange}
        />
      );
    
    case 6:
      return (
        <GoalsStep
          formData={formData}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          handleCheckboxChange={handleCheckboxChange}
        />
      );
    
    default:
      return null;
  }
}
